import { render, staticRenderFns } from "./FactorSelectionNode.vue?vue&type=template&id=597b168b&scoped=true"
import script from "./FactorSelectionNode.vue?vue&type=script&lang=ts"
export * from "./FactorSelectionNode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597b168b",
  null
  
)

export default component.exports